import { useField } from 'formik';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  field: {
    margin: theme.spacing(1, 0),
  },
  checkbox: {
    paddingTop: 0,
    paddingBottom: 0
  },
  helperText: {
  }
}));

type Props = {
  name: string;
  label?: string;
  disabled?: boolean;
  touched?: boolean;
  helperText?: string;
  className?: string;
};

const CheckboxField = ({ name, label, disabled, touched: formTouched, helperText, className }: Props) => {
  const { classes, cx } = useStyles();
  const [field, meta] = useField(name);
  const touched = formTouched || meta.touched;
  const currentError = meta.error;

  return (
    <FormControl
      error={touched && Boolean(currentError)}
      className={cx(classes.field, className)}
    >
      <FormControlLabel
        control={(
          <Checkbox
            id={name}
            {...field}
            value={true}
            checked={field.value}
            classes={{ root: classes.checkbox }}
          />
        )}
        label={label}
        disabled={disabled}
      />
      {((touched && currentError) || helperText) && (
        <FormHelperText className={classes.helperText}>
          {(touched && currentError) || helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default CheckboxField;
